import { PersonRole } from '../enm/PersonRole';
import { Country } from '../enm/Country';
const euCountries = [Country.AU, Country.BE, Country.BG, Country.HR, Country.CY, Country.CZ, Country.DE, Country.EE, Country.FI, Country.FR, Country.DE, Country.GR, Country.HU,
    Country.IE, Country.IT, Country.LV, Country.LT, Country.LU, Country.MT, Country.NL, Country.PL, Country.PT, Country.RO, Country.SK, Country.SI, Country.ES, Country.SE];
export const determineMissingRoles = (payload) => {
    var _a, _b, _c, _d, _e, _f;
    if (!((_b = (_a = payload.business_information) === null || _a === void 0 ? void 0 : _a.registered_address) === null || _b === void 0 ? void 0 : _b.country) || !euCountries.includes(payload.business_information.registered_address.country)) {
        return [];
    }
    const personRoles = ((_e = (_d = (_c = payload.business_information) === null || _c === void 0 ? void 0 : _c.persons) === null || _d === void 0 ? void 0 : _d.flatMap) === null || _e === void 0 ? void 0 : _e.call(_d, person => person.person_role)) || [];
    if (((_f = payload.business_information) === null || _f === void 0 ? void 0 : _f.is_registered) === true) {
        const missingRoles = [];
        const oneOfRequiredRoles = [PersonRole.ULTIMATE_BENEFICIAL_OWNER, PersonRole.ALTERNATIVE_BENEFICIAL_OWNER];
        const missingOneOf = oneOfRequiredRoles.filter(function (requiredRole) {
            return !personRoles.includes(requiredRole);
        });
        if (missingOneOf.length === oneOfRequiredRoles.length) {
            missingRoles.push(...missingOneOf);
        }
        if (!personRoles.includes(PersonRole.LEGAL_REPRESENTATIVE)) {
            missingRoles.push(PersonRole.LEGAL_REPRESENTATIVE);
        }
        return missingRoles;
    }
    return [PersonRole.OWNER].filter(function (requiredRole) {
        return !personRoles.includes(requiredRole);
    });
};
